// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3_19t","footer":"ReportModalFilter_footer__nWLm9"};